import { useEffect } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import { KIND_META } from "@/components/sections/marketplaceMapConstants";

const makeIcon = (color) =>
  L.divIcon({
    html: `<div class="map-pin-dot" style="background:${color}"></div>`,
    className: "",
    iconSize: [16, 16],
    iconAnchor: [8, 8],
  });

const RecenterOnZoomChange = ({ zoom }) => {
  const map = useMap();
  useEffect(() => {
    if (zoom === "us") {
      map.setView([39.5, -98.35], 4, { animate: true });
    } else {
      map.setView([15, 10], 2, { animate: true });
    }
  }, [zoom, map]);
  return null;
};

export const MarketplaceMapCanvas = ({ zoom, markers, usingLive }) => (
  <div
    data-testid="marketplace-map-canvas"
    className="rr-leaflet mt-8 relative h-[420px] md:h-[520px] rounded-[2rem] overflow-hidden border border-rr-line z-0"
  >
    <MapContainer
      center={[39.5, -98.35]}
      zoom={4}
      scrollWheelZoom={false}
      dragging={true}
      doubleClickZoom={true}
      zoomControl={true}
      style={{ height: "100%", width: "100%" }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <RecenterOnZoomChange zoom={zoom} />
      {markers.map((m, i) => (
        <Marker key={`${m.kind}-${m.city}-${i}`} position={[m.lat, m.lng]} icon={makeIcon(KIND_META[m.kind].color)}>
          <Popup>
            <span className="font-bold">{KIND_META[m.kind].label}</span>
            <br />
            {m.city}
          </Popup>
        </Marker>
      ))}
    </MapContainer>

    <div className="absolute bottom-5 left-5 z-[500] bg-rr-navy text-white text-xs font-bold px-3 py-1.5 rounded-lg pointer-events-none">
      {usingLive ? "Live Marketplace" : zoom === "us" ? "USA Marketplace (Preview)" : "Global Marketplace (Preview)"}
    </div>
  </div>
);
